import { flatten as _flatten } from 'lodash';

const getDefaultOptions = options => {
  return _flatten(options?.map(o => o.options));
};

export default getDefaultOptions;
